import React, { useState, useEffect } from 'react';
import './HomeAlertModal.css';

const HomeAlertModal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const storageKey = 'devtracker_neural_ingress_alert_acknowledged';

    useEffect(() => {
        const hasAcknowledge = localStorage.getItem(storageKey);
        if (!hasAcknowledge) {
            // Slight delay for "WOW" entrance effect
            const timer = setTimeout(() => setIsVisible(true), 1200);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcknowledge = () => {
        localStorage.setItem(storageKey, 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="home-alert-overlay">
            <div className="home-alert-modal glass-card animate-scale-up">
                <div className="alert-header">
                    <div className="alert-badge neon-border">DevTracker SYSTEM ALERT</div>
                    <i className="fa-solid fa-triangle-exclamation alert-icon-main"></i>
                </div>
                
                <div className="alert-body">
                    <h2 className="alert-title">Critical System Transparency</h2>
                    <div className="alert-message-box">
                        <p className="warning-text">
                            <strong>[!] CAUTION:</strong> DAIV-X AI & Resume Mode are not working properly soon fix it. We are currently calibrating the extraction weights for 100% fidelity.
                        </p>
                        <p className="security-text">
                            <strong>[S] SECURITY:</strong> Security Patch 4.3.0 has been deployed to harden dossier integrity and prevent unauthorized neural overrides.
                        </p>
                    </div>
                </div>

                <div className="alert-footer">
                    <button className="btn btn-primary btn-glow acknowledge-btn" onClick={handleAcknowledge}>
                        ACKNOWLEDGE SYSTEMS
                    </button>
                    <div className="alert-auto-dismiss">Manual authentication required for dismissal.</div>
                </div>
            </div>
        </div>
    );
};

export default HomeAlertModal;
